import { topicPartQuestionRepository } from "../../../providers/repositories/topicPartQuestionRepository";
import { toast } from "react-toastify";
import { t } from "i18next";
import Logger from "../../../utils/Logger";

export const deleteTopicPartQuestionUseCase = {
    async exec(id: string | number): Promise<boolean> {
        try {
            await topicPartQuestionRepository.delete(id);
            toast.success(t("action.deleteSuccess"));
            return true;
        } catch (error) {
            Logger.error("deleteTopicPartQuestionUseCase", error);
            toast.error(t("action.deleteError"));
        }
        return false;
    },
};
